import { createSlice } from '@reduxjs/toolkit';
import { getAllTypekeys } from './thunks';

// Initial state for Redux store:
export const initialStateTypeKeys = {
  type_keys: [],
  loading: false,
};

const typekeysSlice = createSlice({
  name: 'type_keys',
  initialState: initialStateTypeKeys, // Define initial state
  reducers: {
    setTypekeys: (state: any, action: any) => {
      state.type_keys = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTypekeys.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllTypekeys.fulfilled, (state, action) => {
      state.type_keys = action.payload;
      state.loading = false;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setTypekeys } = typekeysSlice.actions;

// Export reducer generated by "createSlice()":
export default typekeysSlice.reducer;
